import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as lotesApi from '../../api/lotes';
import { useExigeEmpresaEspecifica } from '../../hooks/useExigeEmpresaEspecifica';
import AvisoSelecioneEmpresa from '../../components/common/AvisoSelecioneEmpresa';
import PageHeader from '../../components/common/PageHeader';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import EmptyState from '../../components/common/EmptyState';
import Skeleton from '../../components/common/Skeleton';
import { usePaginacao } from '../../hooks/usePaginacao';
import { formatDate } from '../../utils/date';

export default function Lotes() {
  const { bloqueado, carregandoEmpresas, semEmpresaCadastrada } = useExigeEmpresaEspecifica();
  const [itens, setItens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState('');
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (bloqueado) {
      setLoading(false);
      return;
    }
    lotesApi
      .listLotes()
      .then((r) => setItens(r.data))
      .catch(() => setErro('Erro ao carregar lotes.'))
      .finally(() => setLoading(false));
  }, [bloqueado]);

  const filtrados = itens.filter(
    (l) =>
      l.codigo.toLowerCase().includes(busca.toLowerCase()) ||
      l.produto.nome.toLowerCase().includes(busca.toLowerCase()) ||
      l.fornecedor.nome.toLowerCase().includes(busca.toLowerCase())
  );
  const { paginados, Paginacao } = usePaginacao(filtrados);

  if (carregandoEmpresas) return <LoadingSpinner />;

  return (
    <div>
      <PageHeader titulo="Entradas (Lotes)" subtitulo="Recebimentos de fornecedores" acaoLabel="Nova entrada" acaoTo="/lotes/novo" />

      {erro && (
        <div className="sf-login-alert mb-3">
          <i className="bi bi-exclamation-circle" />
          {erro}
        </div>
      )}

      {bloqueado && <AvisoSelecioneEmpresa semEmpresaCadastrada={semEmpresaCadastrada} />}

      {!bloqueado && (
        <div className="sf-table-card">
          <div className="sf-table-toolbar">
            <div className="sf-search">
              <i className="bi bi-search" />
              <input placeholder="Buscar por código, produto ou fornecedor..." value={busca} onChange={(e) => setBusca(e.target.value)} />
            </div>
          </div>

          {loading ? (
            <div className="p-4">
              <Skeleton linhas={6} />
            </div>
          ) : paginados.length === 0 ? (
            <EmptyState icon="bi-truck" titulo="Nenhuma entrada registrada" texto="Registre o recebimento de um fornecedor." acaoLabel="Nova entrada" acaoTo="/lotes/novo" acaoIcon="bi-truck" />
          ) : (
            <>
              <div className="table-responsive">
                <table className="sf-table">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Código</th>
                      <th>Produto</th>
                      <th>Fornecedor</th>
                      <th>Qualidades</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {paginados.map((l) => (
                      <tr key={l.id_lote}>
                        <td>{formatDate(l.data_entrada)}</td>
                        <td>{l.codigo}</td>
                        <td>
                          <span className="d-flex align-items-center gap-2">
                            <span className="sf-cell-icon"><i className="bi bi-truck" /></span>
                            <span className="sf-cell-title">{l.produto.nome}</span>
                          </span>
                        </td>
                        <td>{l.fornecedor.nome}</td>
                        <td>
                          <div className="d-flex flex-wrap gap-1">
                            {l.itens.map((i) => (
                              <span key={i.id_item_lote} className="sf-badge sf-badge-neutral sf-badge-plain">
                                {i.qualidade.nome}: {Number(i.quantidade_recebida)} {i.unidade_medida.sigla}
                              </span>
                            ))}
                          </div>
                        </td>
                        <td className="text-end">
                          <Link to={`/lotes/${l.id_lote}`} className="sf-btn sf-btn-ghost">
                            <i className="bi bi-eye" />
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <Paginacao />
            </>
          )}
        </div>
      )}
    </div>
  );
}
